import _asyncToGenerator from "C:/Users/Fanni/OneDrive/Asztali g\xE9p/brandfashion/EmptyYS-2020/vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
export default {
  name: 'Login',
  mixins: [validationMixin],
  data: function data() {
    return {
      email: '',
      password: '',
      isProcessing: false
    };
  },
  activated: function activated() {
    this.$v.$reset();
  },
  methods: {
    showForgotPassword: function showForgotPassword() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.commit("setState", {
                  key: "loginIsActive",
                  value: false
                });

              case 2:
                _this.$store.commit("setState", {
                  key: "forgotPasswordIsActive",
                  value: true
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    showCreateAccount: function showCreateAccount() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log("x");
                _context2.next = 3;
                return _this2.$store.commit("setState", {
                  key: "loginIsActive",
                  value: false
                });

              case 3:
                _this2.$store.commit("setState", {
                  key: "createAccountIsActive",
                  value: true
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    closePopup: function closePopup() {
      this.$store.commit("setState", {
        key: "loginIsActive",
        value: false
      });
    },
    login: function login() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _email, password, res;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this3.$v.$touch();

                if (!_this3.$v.$invalid) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return");

              case 4:
                _this3.isProcessing = true; // console.log(this.$swell);

                _email = _this3.email, password = _this3.password;
                _context3.next = 8;
                return _this3.$swell.account.login(_email, password);

              case 8:
                res = _context3.sent;
                _this3.isProcessing = false;

                if (!(!res || res === null)) {
                  _context3.next = 12;
                  break;
                }

                throw new Error('Error');

              case 12:
                _this3.$store.dispatch('showNotification', {
                  message: _this3.$t('account.login.success')
                }).then(function () {
                  window.location.reload();
                }); // this.$router.push(this.localePath('/account/orders/'))


                _context3.next = 18;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](0);

                _this3.$store.dispatch('showNotification', {
                  message: _this3.$t('account.login.error'),
                  type: 'error'
                });

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 15]]);
      }))();
    }
  },
  validations: {
    email: {
      required: required,
      email: email
    },
    password: {
      required: required
    }
  }
};